module.exports = __webpack_public_path__ + "static/media/Groups.396695cd.png";